import { createRouter, createWebHistory } from 'vue-router'
import { logPageLoad } from '@/utils/localStorage'
import HomePage from '../views/HomePage.vue'
import YearPage from '../views/YearPage.vue'
import MakePage from '../views/MakePage.vue'
import ModelPage from '../views/ModelPage.vue'
import OwnPage from '../views/OwnPage.vue'
import FormPage from '../views/FormPage.vue'
import InsurancePage from '../views/InsurancePage.vue'
import InsuranceCompanyPage from '../views/InsuranceCompanyPage.vue'
import GenderPage from '../views/GenderPage.vue'
import MarriedPage from '../views/MarriedPage.vue'
import BirthMonthPage from '../views/BirthMonthPage.vue'
import BirthDayPage from '../views/BirthDayPage.vue'
import BirthYearPage from '../views/BirthYearPage.vue'
import IncidentsPage from '../views/IncidentsPage.vue'
import TicketDetailsPage from '../views/TicketDetailsPage.vue'
import NamePage from '../views/NamePage.vue'
import AnotherDriverPage from '../views/AnotherDriverPage.vue'
import CurrentAddressPage from '../views/CurrentAddressPage.vue'
import HomeOwnershipPage from '../views/HomeOwnershipPage.vue'
import BundleHomePage from '../views/BundleHomePage.vue'
import EmailAddressPage from '../views/EmailAddressPage.vue'
import GetQuotesPage from '../views/GetQuotesPage.vue'
import AcceptedPage from '../views/AcceptedPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/year',
    name: 'Year',
    component: YearPage
  },
  {
    path: '/make',
    name: 'Make',
    component: MakePage
  },
  {
    path: '/model',
    name: 'Model',
    component: ModelPage
  },
  {
    path: '/own',
    name: 'Own',
    component: OwnPage
  },
  {
    path: '/form',
    name: 'Form',
    component: FormPage
  },
  {
    path: '/insurance',
    name: 'Insurance',
    component: InsurancePage
  },
  {
    path: '/insurance-company',
    name: 'InsuranceCompany',
    component: InsuranceCompanyPage
  },
  {
    path: '/gender',
    name: 'Gender',
    component: GenderPage
  },
  {
    path: '/married',
    name: 'Married',
    component: MarriedPage
  },
  {
    path: '/birth-month',
    name: 'BirthMonth',
    component: BirthMonthPage
  },
  {
    path: '/birth-day',
    name: 'BirthDay',
    component: BirthDayPage
  },
  {
    path: '/birth-year',
    name: 'BirthYear',
    component: BirthYearPage
  },
  {
    path: '/incidents',
    name: 'Incidents',
    component: IncidentsPage
  },
  {
    path: '/ticket-details',
    name: 'TicketDetails',
    component: TicketDetailsPage
  },
  {
    path: '/name',
    name: 'Name',
    component: NamePage
  },
  {
    path: '/another-driver',
    name: 'AnotherDriver',
    component: AnotherDriverPage
  },
  {
    path: '/current-address',
    name: 'CurrentAddress',
    component: CurrentAddressPage
  },
  {
    path: '/home-ownership',
    name: 'HomeOwnership',
    component: HomeOwnershipPage
  },
  {
    path: '/bundle-home',
    name: 'BundleHome',
    component: BundleHomePage
  },
  {
    path: '/email-address',
    name: 'EmailAddress',
    component: EmailAddressPage
  },
  {
    path: '/get-quotes',
    name: 'GetQuotes',
    component: GetQuotesPage
  },
  {
    path: '/accepted',
    name: 'Accepted',
    component: AcceptedPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫：记录页面加载事件
router.afterEach((to) => {
  // 使用nextTick确保页面已经渲染完成
  setTimeout(() => {
    const routeName = to.path === '/' ? 'home' : to.path.substring(1).replace(/-/g, '');
    logPageLoad(routeName);
  }, 100);
})

export default router
